/* eslint-disable no-restricted-globals */

const VERSION = 'v2025-08-14-01'
const STATIC_CACHE = `static-${VERSION}`
const RUNTIME_CACHE = `runtime-${VERSION}`

// Opcional: se você quiser pré-cachear alguns assets fixos (favicons, logo), liste aqui:
const PRECACHE_URLS = [
  // '/favicon.ico',
  // '/logo192.png',
  // '/manifest.json',
]

// INSTALL
self.addEventListener('install', (event) => {
  self.skipWaiting() // ativa SW novo sem esperar
  event.waitUntil(
    caches.open(STATIC_CACHE).then((cache) => cache.addAll(PRECACHE_URLS))
  )
})

// ACTIVATE
self.addEventListener('activate', (event) => {
  event.waitUntil(
    caches.keys().then((names) =>
      Promise.all(
        names
          .filter((n) => ![STATIC_CACHE, RUNTIME_CACHE].includes(n))
          .map((n) => caches.delete(n))
      )
    ).then(() => self.clients.claim())
  )
})

// FETCH
self.addEventListener('fetch', (event) => {
  const req = event.request

  // 1) Ignore tudo que não for GET (POST/PUT/DELETE não devem ir para cache)
  if (req.method !== 'GET') {
    event.respondWith(fetch(req))
    return
  }

  const url = new URL(req.url)

  // 2) Não cachear chamadas de API
  if (url.pathname.startsWith('/api/')) {
    event.respondWith(networkFirst(req))
    return
  }

  // 3) Navegação (index.html): SEMPRE buscar da rede (no-store) e não armazenar
  if (req.mode === 'navigate') {
    event.respondWith(
      fetch(new Request(req, { cache: 'no-store' })).catch(() =>
        // fallback: se offline e tiver um index em cache (caso tenha sido precacheado)
        caches.match('/index.html')
      )
    )
    return
  }

  // 4) Estratégias por tipo de asset
  // JS/CSS com hash: cache-first
  if (/\.(?:js|css)$/.test(url.pathname) && /\/static\//.test(url.pathname)) {
    event.respondWith(cacheFirst(req, STATIC_CACHE))
    return
  }

  // Imagens / fontes: stale-while-revalidate
  if (/\.(?:png|jpg|jpeg|webp|gif|svg|ico|ttf|otf|woff|woff2)$/.test(url.pathname)) {
    event.respondWith(staleWhileRevalidate(req, RUNTIME_CACHE))
    return
  }

  // Demais GETs: network-first com fallback ao cache
  event.respondWith(networkFirst(req))
})

// Helpers

async function cacheFirst(request, cacheName) {
  const cache = await caches.open(cacheName)
  const cached = await cache.match(request)
  if (cached) return cached

  const res = await fetch(request)
  if (res && res.ok) cache.put(request, res.clone())
  return res
}

async function staleWhileRevalidate(request, cacheName) {
  const cache = await caches.open(cacheName)
  const cached = await cache.match(request)

  const networkPromise = fetch(request)
    .then((res) => {
      if (res && res.ok) cache.put(request, res.clone())
      return res
    })
    .catch(() => undefined)

  // retorna rápido o cache se existir; senão, espera a rede
  return cached || networkPromise || fetch(request)
}

async function networkFirst(request) {
  try {
    // tenta sempre a rede, sem reusar cache do browser
    const res = await fetch(new Request(request, { cache: 'no-store' }))
    return res
  } catch {
    const cached = await caches.match(request)
    if (cached) return cached
    // fallback extra: tentar sem querystring (útil pra assets com qs)
    const url = new URL(request.url)
    url.search = ''
    return caches.match(url.toString())
  }
}
